import { formatZodErrors } from '@hashnode/docs'
import { getConfig, getLogger } from '@hashnode/file-parsing'
import fs from 'fs-extra'
import path from 'path'
import { z, ZodError } from 'zod'

const logger = getLogger()
export const configSchema = z
	.object({
		linkedProjectId: z.string(),
		previewProjectId: z.string().optional(),
	})
	.strict()

export type Config = z.infer<typeof configSchema>

export function getHashnodeConfig(cwd: string): Config {
	const filePath = path.join(cwd, 'hashnode.ts')
	const configContent = getConfig({
		filePath,
	})
	if (!configContent) {
		logger.debug('No hashnode.ts found; creating a new one.')
		const config: Config = { linkedProjectId: '', previewProjectId: '' }
		const configString = `export default ${JSON.stringify(config, null, 2)};`

		fs.writeFileSync(`${cwd}/hashnode.ts`, JSON.stringify(configString, null, 2))
		return config
	}

	try {
		return configSchema.parse(configContent)
	} catch (error) {
		if (error instanceof ZodError) {
			formatZodErrors(filePath, error)
		}
		logger.exit(`Invalid configuration found in ${cwd}/hashnode.ts.`)

		throw error
	}
}

export function writeConfig(cwd: string, config: Partial<Config>): Config {
	const initialData = getHashnodeConfig(cwd)

	const mergedConfig = { ...initialData, ...config }

	const configString = `export default ${JSON.stringify(mergedConfig, null, 2)};`

	fs.writeFileSync(`${cwd}/hashnode.ts`, configString)
	return mergedConfig
}
